import Vue from 'vue'
import moment from 'moment'
import {
	INDEXHOTEL,
	FETCH_LOADING
} from './mutations-type.js'


export default {
	async getIndexHotel ({commit}, res) {

	},
  	async fetchLoading ({commit}, res) {
  		commit(FETCH_LOADING, res)
  	}
}


// WEBPACK FOOTER //
// ./src/store/actions.js